import i18n from 'config/i18n';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import * as yup from 'yup';

import { PlannedHour } from 'components/types';

import { getLocale } from 'utils/date';

dayjs.extend(minMax);

const addPlannedHoursDialog = (
  plannedHours: PlannedHour[],
  editValues: any
) => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    baseplanId: yup.mixed().required(),
    startDate: yup
      .date()
      .test(
        'date-already-used',
        () => t('capplan_baseplan_startdate_already_used'),
        (v) => {
          return (
            editValues?.startDate === v?.toISOString() ||
            !plannedHours.some((h) => h.startDate === v?.toISOString())
          );
        }
      )
      .required()
  });
};

export default addPlannedHoursDialog;
